import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';

import * as S from './style';

function FloatingCartButton({ opened, products, isTransitioning, handleToggle, location }) {
  return (
    <S.FloatingCartButton
      type="button"
      onClick={() => handleToggle(!opened)}
      location={location}
      isTransitioning={isTransitioning}
      opened={opened}
      variant="outlined"
      rounded
    >
      <S.FloatingCartButtonBadge>{products.length}</S.FloatingCartButtonBadge>
      <Icon name="shopping-bag" />
    </S.FloatingCartButton>
  );
}

export { FloatingCartButton };
